<template>
    <div class="component-settings-store-add">
        <div class="row">
            <div class="col-12 no-padding">
                <div class="el-card__header text-left" slot="header" style=" border: 1px solid #EBEEF5">
                    <div class="row center-align-vert">
                        <div class="col-6 center-align-vert">
                            <el-button @click="$router.push({ 'name': 'settings-stores'})" class="inline fl mr-10" icon="el-icon-back"></el-button>
                            <h4 style="display: inline">Store {{$route.query.store_id}}</h4>
                        </div>
                        <div class="col-6 fr">
                            <el-button class="fr" type="primary" @click="submit" @submit.prevent="submit">Save</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-card class="box-card" id="main-header" shadow="never"
                 style="border: none; border-radius: 0px; min-height: 400px; background-color: #f4f7fa;"
                 body-style="background-color: #f4f7fa; padding: 20px 0px;"
        >
            <div class="row">
                <div class="col-12">
                    <h5 class="title-left-bold">Store details</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never">
                        <div class="row">
                            <div class="col-12">
                                <el-form ref="form" :model="form" label-width="120px">
                                    <el-form-item label="Store ID">
                                        <el-input v-model="form.store_id"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Name">
                                        <el-input v-model="form.store_name"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Active" class="text-left">
                                        <el-switch v-model="form.active"></el-switch>
                                    </el-form-item>
                                    <el-form-item label="Surface">
                                        <el-input v-model="form.store_square_meters"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </el-card>
                    <h5 class="title-left-bold mt-50">Store times</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card text-left" shadow="never">
                        <div class="row">
                            <div class="col-12">
                                <el-form ref="form" :model="form" label-width="120px">
                                    <el-form-item label="Monday">
                                        <el-time-select
                                            v-model="form.opening_times.monday.open"
                                            placeholder="Open"
                                            :picker-options="{
                                                start: '08:00',
                                                step: '00:30',
                                                end: '22:00'
                                            }">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.monday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.monday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Tuesday">
                                        <el-time-select
                                            v-model="form.opening_times.tuesday.open"
                                            placeholder="Open">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.tuesday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.tuesday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Wednesday">
                                        <el-time-select
                                            v-model="form.opening_times.wednesday.open"
                                            placeholder="Open">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.wednesday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.wednesday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Thursday">

                                        <el-time-select
                                            v-model="form.opening_times.thursday.open"
                                            placeholder="Open">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.thursday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.thursday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Friday">

                                        <el-time-select
                                            v-model="form.opening_times.friday.open"
                                            placeholder="Open">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.friday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.friday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Saturday">
                                        <el-time-select
                                            v-model="form.opening_times.saturday.open"
                                            placeholder="Open"
                                            class="time-select-input">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.saturday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.saturday"></el-input>
                                    </el-form-item>
                                    <el-form-item label="Sunday">
                                        <el-time-select
                                            v-model="form.opening_times.sunday.open"
                                            placeholder="Open">
                                        </el-time-select>
                                        <el-time-select
                                            arrow-control
                                            v-model="form.opening_times.sunday.close"
                                            placeholder="Close"
                                            class="ml-5-howrly" :picker-options="{start: '08:00', step: '00:30', end: '22:00' }">
                                        </el-time-select>
                                        <el-input class="min-hours-field" v-model="form.min_hours.sunday"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken } from '../../functions.js'
export default {
    data () {
        return {
            form: { 'org_id': 1, 'store_id': this.$route.query.store_id, 'store_name': 'Name', 'store_square_meters': 0, 'opening_times': { 'friday': { 'open': '10:00', 'close': '18:00' }, 'monday': { 'open': '12:00', 'close': '18:00' }, 'sunday': { 'open': '12:00', 'close': '17:00' }, 'tuesday': { 'open': '10:00', 'close': '18:00' }, 'saturday': { 'open': '10:00', 'close': '20:00' }, 'thursday': { 'open': '10:00', 'close': '21:00' }, 'wednesday': { 'open': '10:00', 'close': '18:00' } }, 'opening_sunday': 'first_sunday', 'min_hours': { 'friday': 14, 'monday': 5, 'sunday': 5, 'tuesday': 7, 'saturday': 7, 'thursday': 7, 'wednesday': 7 }, 'active': true }
        }
    },
    methods: {
        submit () {
            let returnData = JSON.parse(JSON.stringify(this.form))
            for (let day in returnData.opening_times) {
                vue.set(returnData.opening_times[day], 'open', this.getMinutes(returnData.opening_times[day].open))
                vue.set(returnData.opening_times[day], 'close', this.getMinutes(returnData.opening_times[day].close))
            }
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_USERS_API_BASE_URL_DEV : process.env.VUE_APP_USERS_API_BASE_URL) + '/store', returnData, { 'headers': getHeadersWithAccessToken() })
                .then(response => {
                    this.$router.push({ 'name': 'settings-stores', 'params': { 'update': false, 'delete': false, 'add': true, 'store_id': returnData.store_id } })
                })
                .catch(error => {
                    console.log(error)
                })
        },
        getTime (input) {
            let hours = Math.floor(input / 60).toString()
            let minutes = (input % 60).toString()

            if (minutes.length === 1) {
                minutes += '0'
            }
            return hours + ':' + minutes
        },
        getMinutes (input) {
            let hours = input.split(':')[0]
            let minutes = input.split(':')[1]
            return parseInt(hours) * 60 + parseInt(minutes)
        }
    }
}
</script>

<style lang="scss">
.component-settings-store-add {
    p {
        margin-bottom: 0px;
    }
    .el-card__body {
        padding-bottom: 0px !important;
    }
    .el-input__inner {
        max-width: 250px !important;
    }
    .min-hours-field {
        display: inline-block;
        width: 60px !important;
        margin-left: 5px;
        .el-input__inner {
            text-align: center;
        }
    }
    .el-date-editor {
        max-width: 100px;
    }
    .el-input__inner {
        text-align: left;
    }
}
</style>
